import { AfterViewInit, Component, HostListener, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import { productFruits } from 'product-fruits';
import mixpanel from "mixpanel-browser/src/loader-module";
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { ConfigInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ViewPortService } from 'projects/apna-lib/src/lib/services/view-port.service';
import { SeoService } from 'projects/apna-lib/src/lib/services/seo.service';
declare let gtag: Function;
@Component({
  selector: 'fa-loan-welcome',
  templateUrl: './loan-welcome.component.html',
  styleUrls: ['./loan-welcome.component.scss']
})
export class LoanWelcomeComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('content') content: TemplateRef<any>;
  @ViewChild('otpContent') otpContent: TemplateRef<any>;
  @ViewChild('incorrectOtp') incorrectOtp: TemplateRef<any>;
  model: any = {};
  otpModel: any = {};
  otpDataModel = 'users/login-with-mobile-otp';
  timer: number = 59;
  dataModel: string = "users";
  isPartnerLink: boolean = false;
  partnerLogo: string;
  loading: boolean = true;
  userType: string;
  showMobileNumber: boolean = true;
  normalNumber: boolean = true;
  otpMobileNumber: string;
  loanApplicationId: string;
  studentId: string;
  mobileNumber: string;
  otpFields: FormlyFieldConfig[] = []
  layout: FormlyFieldConfig[] = [];
  passportNumber: any;
  mobile: any;
  triggerErrorMessage: boolean;
  errorMessage: string;
  triggerErrorMessageMobile: boolean;
  errorMessageMobile: string;
  showOtpLayout: boolean = false;
  showLayout: boolean = true;
  showForm: boolean = false;
  selectLocationForm: boolean = false;
  notAbleToApplyForm: boolean = false;
  defaultForm: boolean = true;
  showOtpForm: boolean = false;
  step: string = 'defaultForm'
  timerInterval: any;
  orientation: String;
  editMobileNumberString: String;

  configMobileNumberHeader: ConfigInterface = {
    title: "Enter mobile number",
  }

  configOTPHeader: ConfigInterface = {
    title: "Verify Mobile Number",
  }
  loanWidgetConfig: any = this.config.getConfig1("loanWidgetConfig")
  banks: any = this.loanWidgetConfig.bankLogos
  logos: any = this.loanWidgetConfig.marqueeLogos;
  innerHeight: number;


  ngOnChanges(): void {
    this.setLayout();
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row text-primary-dark align-items-center padding-custom",
        fieldGroup: [
          {
            key: "mobile",
            type: "mobile-number",
            templateOptions: {
              required: true,
              label: "Mobile Number",
              hideRequiredMarker: true,
            },
            modelOptions: {
              debounce: { default: 3000 },
              updateOn: "blur"
            },
            asyncValidators: {
              alreadyApplied: {
                expression: async (control: any) => {
                  if (!control) return false;
                  if (!["+91"].includes(control?.value.slice(0, 3))) {
                    this.normalNumber = false;
                  }
                  if (this.loanService.partnerDetails?.uid && (["LNEMD0NB", "LL52YO7E"].includes(this.loanService?.partnerDetails.uid))) {
                    return true;
                  }
                  return true
                },
              },
            },
            expressionProperties: {
              "className": () => {
                if (this.loanService?.partnerDetails?.company?.showAgentCode === true) {
                  return "ms-lg-6 col-lg-9 col-12 mt-2  mobile-number-length"
                }
                else {
                  return "col-lg-9 col-12 mobile-number-length"
                }
              }
            },
            validation: {
              messages: {
                required: 'Mobile number is required',
                alreadyApplied: ''
              },
            }
          },

          {
            key: "passportNumber",
            type: "passportNumber",
            templateOptions: {
              label: "Passport Number",
              hideRequiredMarker: true,
              placeholder: "Enter Passport Number",
              required: true,
            },
            hideExpression: () => {
              if (this.loanService?.partnerDetails?.company?.showAgentCode === true) {
                return false
              }
              else {
                return true
              }
            },
            expressionProperties: {
              "className": () => {
                if (this.loanService.partnerDetails?.company?.showAgentCode === true) {
                  return "ms-lg-6 col-lg-9 col-12 mt-2  passport-number-length"
                }
                else {
                  return "col-lg-9 col-12 passport-number-length"
                }
              }
            },
            validation: {
              messages: {
                required: 'Passport number is required',
              },
            },
          },

          {
            className: this.loanService.partnerDetails?.company?.showAgentCode === true ? "consent text-gray mb-2 ms-lg-6 col-lg-11 col-12 mt-2  passport-number-length" : "consent text-gray col-lg-11 col-12 passport-number-length",
            template: this.loanService?.partnerDetails?.company?.consent ? this.loanService?.partnerDetails?.company?.consent : this.generalConsent
          },


          {
            type: 'text',
            className: this.loanService.partnerDetails?.company?.showAgentCode === true ? "consent text-gray mb-2 ms-lg-6 col-lg-11 col-12 mt-2  passport-number-length" : "consent text-gray col-lg-11 col-12 passport-number-length",
            templateOptions: {
              text: '<p class="text-gray ms-lg-1">By continuing you agree to our <span> <a href="https://webflow.foreignadmits.com/study-abroad/terms-and-conditions" target="_blank"> Terms Conditions & Privacy Policy </a> </span></p>',
            },
          },
        ]
      },

      {
        fieldGroupClassName: "row text-primary-dark align-items-center padding-custom mb-0",
        fieldGroup: [
          {
            type: "button",
            className: "",
            templateOptions: {
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: async () => {
                this.otpMobileNumber = undefined;
                if (this.model?.mobile === "" || this.model?.mobile === undefined || this.model?.passportNumber === "" || this.model?.passportNumber === undefined) {
                  this.model["error"] = "Hello world"
                }
                else {
                  delete this.model.error;
                  this.otpMobileNumber = undefined;
                  if (this.triggerErrorMessage === true) {
                    this.triggerErrorMessage = false;
                    this.errorMessage = ''
                  }
                  if (this.triggerErrorMessageMobile === true) {
                    this.triggerErrorMessageMobile = false;
                    this.errorMessageMobile = ''
                  }

                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                      type: "student",
                      mobile: this.model.mobile
                    }
                    if (this.loanService.partnerDetails) {
                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name

                    }
                    this.trackEvent("Start Button on Loan Widget clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "className": () => {
                if (this.loanService?.partnerDetails?.company?.showAgentCode === true) {
                  return " col-lg-12 col-12 mt-2"
                }
                else {
                  return "col-lg-12 col-12 mt-2"
                }

              },
              "templateOptions.btnType": (model: any) => {
                if (this.loanService.partnerDetails?.uid && (["LNEMD0NB", "LL52YO7E"].includes(this.loanService?.partnerDetails.uid))) {
                  if (this.model?.mobile === "" || this.model?.mobile === undefined || this.model?.passportNumber === "" || this.model?.passportNumber === undefined) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white ms-n2"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom ms-n2"
                  }
                }
                if (this.model?.mobile === "" || this.model?.mobile === undefined) {
                  return "gray disabled w-100 py-3 fw-bold rounded-custom text-white ms-n2"
                }

                else {
                  return "primary w-100 py-3 fw-bold rounded-custom ms-n2"
                }
              }
            }
          }
        ]
      }
    ];
  }

  otpLayout() {
    this.otpFields = [

      {
        key: 'otp',
        type: 'fa-otp',
        className: "rounded rounded-1 custom-otp",
        templateOptions: {
          label: 'Enter OTP',
          placeholder: 'Enter OTP',
          hideLabel: true
        },
      },
    ];
  }

  userData: {};
  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }

  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  generalConsent = this.config.getConfig1("foreignAssist", "generalConsent")

  constructor(
    private loanService: LoanGtmService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
    private modalService: NgbModal,
    private userIdentity: UserIdentityService,
    private config: ConfigService,
    public breakpointObserver: BreakpointObserver,
    private visualViewportService: ViewPortService,
    private seo: SeoService
  ) {
  }

  ngOnInit(): void {
    this.setSeoData();
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
          this.configMobileNumberHeader["showMobileView"] = true;
          this.configOTPHeader["showMobileView"] = true;
        } else {
          this.orientation = 'horizontal';
        }
      });

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    this.loanService.setDefaultDetails();
    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    if (puid) {

      this.isPartnerLink = true;
      this.getPartnerDetails(puid);
    }

    this.setLayout();

    this.dataPreprocessor();
    if (typeof window !== 'undefined') {
      productFruits.init('r7PThLnk4yVYcchg', 'en', {
        username: "Loan Widget",
        role: "student",
      });
      productFruits.safeExec($pf => {
      })
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => { this.loading = false }, 100)
  }

  dataPreprocessor() {
    this.model = { ...this.loanService.studentDetails };

    const leadSource = JSON.parse(sessionStorage.getItem("leadSource"))
    if (leadSource) {
      this.model.leadSource = Object.assign({ ...this.model.leadSource }, leadSource);
    }
    if (this.activatedRoute.snapshot.queryParams?.hasOwnProperty("agentCode") && Object.keys(this.activatedRoute?.snapshot?.queryParams)?.length > 0 && !this.activatedRoute.snapshot.queryParams?.hasOwnProperty("applicationStatus") && !this.activatedRoute.snapshot.queryParams?.hasOwnProperty("uploadDocuments")) {
      this.model.agentCode = Object.assign({ ...this.model.agentCode }, this.activatedRoute?.snapshot?.queryParams);
      sessionStorage.setItem("agentCode", JSON.stringify(this.model.agentCode))
    }
    else if (!this.activatedRoute.snapshot.queryParams?.hasOwnProperty("agentCode") && Object.keys(this.activatedRoute?.snapshot?.queryParams)?.length > 0 && !this.activatedRoute.snapshot.queryParams?.hasOwnProperty("applicationStatus") && !this.activatedRoute.snapshot.queryParams?.hasOwnProperty("uploadDocuments")) {
      this.model.leadSource = Object.assign({ ...this.model.leadSource }, this.activatedRoute?.snapshot?.queryParams);
      sessionStorage.setItem("leadSource", JSON.stringify(this.model.leadSource))
    }
  }

  dataProcessor(data: any) {
    if (data?.whatsAppEnabled) {
      delete data?.whatsAppEnabled;
    }
    if (data?.passportNumber) {
      data.passportNumber = data?.passportNumber.toUpperCase();
    }
    return data;
  }

  redirectFromEditMobileNumber() {
    this.step = 'showForm';
  }

  showOtp(mobile: string) {
    if (this.otpMobileNumber && this.otpMobileNumber === mobile) {
      return;
    }

    this.otpModel = {};
    this.otpMobileNumber = mobile?.toString();
    this.editMobileNumberString = this.otpMobileNumber.replace(/.(?=.{4})/g, '*');

    this.otpModel["mobile"] = mobile?.toString();

    const postObj: any = {
      type: "student",
      isWidget: true,
      mobile: mobile
    };

    if (this.loanApplicationId) {
      this.saveLoanApplication();
    }

    if (this.studentId) {
      this.saveStudentDetails(postObj);
    } else {
      this.postStudentDetails(postObj);
    }
  }

  saveLoanApplication() {
    this.loanService.saveLoanApplication({ id: this.loanApplicationId });
  }

  saveStudentDetails(postObj: any) {
    if (localStorage.getItem("puid")) {
      postObj["puid"] = localStorage.getItem("puid");
    }

    const leadSource = JSON.parse(sessionStorage.getItem("leadSource"));
    if (leadSource) {
      if (!leadSource.uploadDocuments) {
        postObj["leadSource"] = leadSource;
      }
    }

    const agentCode = JSON.parse(sessionStorage.getItem("agentCode"));
    if (agentCode) {
      postObj["agentCode"] = agentCode.agentCode;
    }

    if (this.model?.passportNumber) {
      postObj["passportNumber"] = this.model?.passportNumber;
    }

    this.apiHelper.updateData("users/widget", this.studentId, postObj).subscribe((data: any) => {
      this.sendOtp(postObj.mobile);
    });
  }

  postStudentDetails(postObj: any) {
    if (localStorage.getItem("puid")) {
      postObj["puid"] = localStorage.getItem("puid");
    }

    const leadSource = JSON.parse(sessionStorage.getItem("leadSource"));
    if (leadSource) {
      postObj["leadSource"] = leadSource;
    }

    const agentCode = JSON.parse(sessionStorage.getItem("agentCode"));
    if (agentCode) {
      postObj["agentCode"] = agentCode.agentCode;
    }

    if (this.model?.passportNumber) {
      postObj["passportNumber"] = this.model?.passportNumber;
    }

    this.apiHelper.postData("users", postObj).subscribe((data: any) => {
      this.sendOtp(postObj.mobile);
    });
  }

  async checkMobileAvailable(mobileNo: string) {
    this.mobileNumber = mobileNo;
    let params: any = {
      where: {
        mobile: { like: mobileNo?.replace('+', '') },
      }
    };
    return this.apiHelper.getData("check-existing-loan-application", params)?.then((res: any) => {
      this.userType = res?.userType;
      this.loanApplicationId = res?.loanApplicationId;
      this.studentId = res?.studentId;
      this.modalService.dismissAll();
      return { mobile: mobileNo, partnerId: res?.parentId, type: res?.userType };
    })
  }

  async checkMobilePassportAvailable(mobileNo: string, passportNumber: string) {
    this.mobileNumber = mobileNo;
    let params: any = {
      where: {
        mobile: { like: mobileNo?.replace('+', '') },
        passportNumber: passportNumber?.toUpperCase(),
      }
    };
    return this.apiHelper.getData("check-existing-loan-application-partner", params)?.then((res: any) => {
      this.userType = res?.userType;
      this.loanApplicationId = res?.loanApplicationId;
      this.studentId = res?.studentId;
      this.passportNumber = res?.passportNumber;
      this.mobile = res?.mobile
      // this.loanService.saveLoanApplication({id: this.loanApplicationId});
      this.modalService.dismissAll();
      return { mobile: res?.mobile, passportNumber: res?.passportNumber, partnerId: res?.parentId, type: res?.userType };
    })
  }

  async onSubmit(event: any) {
    this.configOTPHeader.stepEmitter = "showForm"
    if (!event?.error) {
      if (this.loanService.partnerDetails?.uid && (this.loanService.partnerDetails?.uid == "LNEMD0NB" || this.loanService.partnerDetails?.uid == "LL52YO7E")) {
        this.mobileNumber = event?.data?.mobile;
        const val = await this.checkMobilePassportAvailable(this.model?.mobile, this.model.passportNumber);
        if (val.type === "student") {
          if (val) {
            if (!val?.partnerId && !val?.mobile && !val?.passportNumber) {
              this.showOtp(this.model.mobile)
              this.step = 'showOtpForm'

            }
            if ((val?.mobile === this.model.mobile && val?.passportNumber === this.model.passportNumber && val?.partnerId === this.loanService?.partnerDetails?.id) || (val?.mobile === undefined && val?.passportNumber === undefined && val?.partnerId === this.loanService?.partnerDetails?.id)) {
              this.otpModel = {}
              this.showOtp(event?.data?.mobile);
              this.step = 'showOtpForm'
            }
            else if (val?.mobile && val?.mobile !== this.model.mobile) {
              this.triggerErrorMessageMobile = true;
              this.triggerErrorMessage = false;
              this.errorMessageMobile = `Loan application already exists for this passport Number ${val?.passportNumber}`
            }
            else if (val?.passportNumber && val?.passportNumber !== this.model.passportNumber) {
              this.triggerErrorMessage = true
              this.triggerErrorMessageMobile = false;
              this.errorMessage = `Loan application already exists for this mobile Number ${val?.mobile}`
            }
          }

        }
        else {
          this.modalService.open(this.content, { centered: true });
        }
      }
      else {
        const response = await this.checkMobileAvailable(this.model.mobile);
        if (response.type === "student") {
          if (!this.loanService.partnerDetails?.id) {
            const isUploadDocuments = this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments') || this.loanApplicationId;
            if (isUploadDocuments) {
              this.showOtp(this.model.mobile)
              this.step = 'showOtpForm'
            }
            else {
              this.showOtp(this.model.mobile)
              this.step = 'showOtpForm'
            }
          }
          else {
            if (response?.mobile && !response?.partnerId) {
              this.showOtp(this.model.mobile)
              this.step = 'showOtpForm'
            }
            else if (response.mobile == this.model.mobile && response?.partnerId === this.loanService.partnerDetails?.id) {
              const isUploadDocuments = this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments') || this.loanApplicationId;
              if (isUploadDocuments) {
                this.showOtp(this.model.mobile)
                this.step = 'showOtpForm'
              }
              else {
                this.showOtp(this.model.mobile)
                this.step = 'showOtpForm'
              }
            }
            else {
              this.modalService.open(this.content, { centered: true });
            }
          }
        }
        else {
          this.modalService.open(this.content, { centered: true });
        }

      }

      gtag('event', 'mobile_number_entered', {
        'event_category': 'button',
        'event_label': 'Mobile number button',
        'value': "Mobile number"  
      });

      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.model?.mobile
      })
    }
  }

  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid)?.subscribe({
      next: (response: any) => {
        // Handle successful response
        let partnerDetails = { ...response };
        localStorage.setItem('puid', partnerUid);
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
        this.layout = undefined;
        let newModel = { ...this.model };
        this.model = undefined;
        this.model = { ...newModel }
        this.setLayout();
      },
      error: (error: any) => {
        this.route.navigate(['/'])
        this.isPartnerLink = false;
      }
    });
  }

  async sendOtp(mobile?: string) {
    this.startTimer();
    try {
      await this.userIdentity.sendOtp(this.loanService.studentDetails?.mobile ?? mobile).then(() => {
        setTimeout(() => {
          this.apiHelper.openSnackBar("OTP sent successfully");
        }, 200)
      });

      this.otpLayout();
      let newModel = { ...this.otpModel };
      this.otpModel = undefined;
      this.otpModel = { ...newModel };
      this.showLayout = false;
      this.showOtpLayout = true;



    } catch (error) {
      this.apiHelper.openSnackBar("Unable to send,you have exceeded the limit please try again later!");
    }
  }

  startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval); // Clear the previous interval if it exists
    }
    this.timer = 59; // Set initial value
    this.timerInterval = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.timerInterval);
        this.timer = 60; // Reset timer
      }
    }, 1000);
  }

  submitOtp() {
    this.apiHelper.postData(this.otpDataModel, {
      mobile: this.mobileNumber,
      otp: this.otpModel.otp
    })?.subscribe(
      (loginResponse: any) => {
        this.userIdentity.storeUserDetails(loginResponse);
        this.loanService.saveStudentDetails(loginResponse?.userDetails).then(() => {
          this.studentId = this.loanService.studentDetails.id;
          if (loginResponse?.userDetails?.parentId !== undefined) {
            this.isPartnerLink = true;
            localStorage.setItem('puid', loginResponse?.userDetails?.puid)
            this.getPartnerDetails(loginResponse?.userDetails?.puid);
            let route = "";
            if (this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments')) {
              route = 'upload-documents/';
              this.loanService.loanDetails.id = this.loanApplicationId
            }
            else if (this.loanApplicationId && !this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments')) {
              route = "application-status/";
              this.loanService.loanDetails.id = this.loanApplicationId
            }
            else if (this.studentId) {
              route = "personal-details/"
            }

            if (this.isPartnerLink) {
              this.modalService.dismissAll();
              this.route.navigate([route + (this.loanService?.partnerDetails?.uid !== undefined ? this.loanService?.partnerDetails?.uid : loginResponse?.userDetails?.puid)]);
              return;
            }
          }
          else {
            let route = "";
            if (this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments')) {
              route = 'upload-documents/';
              this.loanService.loanDetails.id = this.loanApplicationId;
            }
            else if (this.loanApplicationId && !this.activatedRoute.snapshot.queryParamMap.get('uploadDocuments')) {
              route = "application-status/";
              this.loanService.loanDetails.id = this.loanApplicationId;
            }
            else if (this.studentId) {
              route = "personal-details/"
            }
            this.modalService.dismissAll();
            this.route.navigate([route]);
            return;
          }

          // this.loanService.startRefreshToken();
        })
      },
      (error: any) => {
        setTimeout(() => {
          this.otpFields = undefined;

          setTimeout(() => {
            this.otpLayout();

          }, 10)
        }, 10)
        delete this.otpModel?.otp;
        this.apiHelper.openSnackBar('You have entered wrong otp')
        return;
      }
    )

    gtag('event', 'otp_submit', {
      'event_category': 'button',
      'event_label': 'OTP submit button',
      'value': "OTP submit"  
    });

    gtag('config','G-LW5LDX8EDG',{
      'user_id': this.model?.mobile
    })
  }

  backToMobileNumber() {
    this.otpFields = undefined;
    this.otpModel = undefined;
    this.showOtpLayout = false;
    this.setLayout();
    let newModel = { ... this.model }
    this.model = undefined
    this.showLayout = true;
    setTimeout(() => {
      this.model = { ...newModel }
    }, 100)
  }

  showFormLayout() {
    gtag('event', 'apply_now', {
      'event_category': 'button',
      'event_label': 'Apply now button',
      'value': "Apply now"  
    });   

    this.step = 'showForm'
    this.configMobileNumberHeader.stepEmitter = "defaultForm"
  }

  emitStep(event: any) {

    if (event === 'defaultForm') {
      this.model.mobile = ""
    }
    this.step = event
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate([''])
  }

  checkStatus() {
    this.step = 'showForm'
    this.configMobileNumberHeader.stepEmitter = "defaultForm"
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid], { queryParams: { applicationStatus: true } });
      return;
    }
    this.route.navigate([''], { queryParams: { applicationStatus: true } })
  }

  setSeoData() {
    const seoObj = {
      title: "ForeignAdmits | Abroad Education Loan",
      metaKey: "education loan study abroad, education loan for abroad studies, student loans for studying abroad, study loan for abroad, study abroad consultants, education loan, student accommodation abroad, student visa USA, foreignadmits, foreignadmits education loan, abroad educational loan, educational loans to study abroad, educational loan for study in abroad, educational loan for abroad studies, educational loan for study abroad, education loans for studying abroad, education loan for abroad study, foreign education loan, education loan abroad, loans for education abroad, loan for education abroad, hdfc education loan credila, abroad education loans, education loan to study abroad, education loan for studies abroad, abroad education loan, study abroad education loan, loan for overseas education, education loan HDFC credila, student loan for abroad studies, students loan to study abroad, student loan for abroad study, study abroad student loans, study abroad loans, abroad studies loan, studies abroad, educational loan from Bank of Baroda, Bank of Baroda education loan, education loan Bank of Baroda, education loan in Bank of Baroda, education loan of Bank of Baroda, education loan for study in abroad, education loan for abroad studies, education loan for study abroad, education loan for abroad study, foreign bank, abroad studies, loan for students to study abroad, study abroad student loan, loans for students studying abroad, student loan for studying abroad, student loans to study abroad, study loan for abroad, study abroad loan, loan for studies abroad, loan for abroad study, studying abroad loans, loan for study in abroad, loans for studying abroad, loan for study abroad, loan to study abroad, education loan in BOB, BOB education loan, abroad assignment today, Bank of Baroda education loan interest rate, study loan for Canada, loan to study in Canada, loan for study in Canada, education loan in Canada, loan for education in Canada, education loan Canada, Canada education loan, education loan for Canada, abroad education, bank of Baroda education loan for abroad, bank of Baroda abroad education loan, sbi global ed vantage scheme, studies overseas, wemakescholars login, sbi online education loan apply, what is a broad, student loans for Canada, student loan for Canada, MBA colleges in Vadodara, education loan for abroad studies without collateral, government education loan for study abroad, foreign study, student loan Bank of Baroda, education loan abroad studies without collateral, we make scholars education loan, education in foreign, foreign studies, student loan for USA, student loan USA, salary of CIMA in India, CIMA India salary, scholar number, US bank interest rates, student loan abroad, foreign education loan, student loan for abroad, loans for foreign education, student loans abroad, education loan for abroad studies by Indian government, student loan without collateral, foreign education, tangible collateral security, for study, yes world token price INR today, documents required for education loan in Bank of Baroda, abroad study loan from SBI, bank study, abroad education loan without collateral, education loan for UK, education loan for US, UK education loan, education loans in US, SBI online",
      metaDesc: "Looking for an education loan to study abroad? ForeignAdmits can help you find the best student loans for studying abroad. We also offer student accommodation abroad and other abroad services. Click to know more.",
    };
    this.seo.addSeoObj(seoObj);
  }

  goBackToLocationForm(){
    this.step = 'selectLocationForm';
  }
}
